module.exports = __webpack_public_path__ + "b5aac5e773a917890c6c0d0a5f70c5cc.png";